document.addEventListener('DOMContentLoaded', function () {
    // Select all accordion blocks
    const accordionBlocks = document.querySelectorAll('.component-accordion');

    // If no accordion blocks are found, exit early
    if (accordionBlocks.length === 0) return;

    // Add event listeners to each accordion block
    accordionBlocks.forEach(block => {
        block.addEventListener('click', function () {
            const content = this.querySelector('span');
            const iconContainer = this.querySelector('.component-accordion__accordion__icon');
            
            // Check if the content is currently visible or not
            if (content.style.maxHeight) {
                // If visible, slide it up
                content.style.maxHeight = null;

                // Change icon to "+"
                iconContainer.innerHTML = `
                    <svg class="icon-plus" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line y1="19" x2="40" y2="19" stroke="#1E285F" stroke-width="2"/>
                        <line x1="21" y1="0" x2="21" y2="40" stroke="#1E285F" stroke-width="2"/>
                    </svg>
                `;
            } else {
                // If hidden, slide it down
                content.style.maxHeight = content.scrollHeight + "px";

                // Change icon to "-"
                iconContainer.innerHTML = `
                    <svg class="icon-minus" width="40" height="40" viewBox="0 0 40 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line y1="1" x2="40" y2="1" stroke="#1E285F" stroke-width="2"/>
                    </svg>
                `;
            }
        });
    });
});